import { useEffect, useState } from "react";

export function useDebounce<T>(
  value: T,
  delay: number = 500,
  onTimeOut?: () => void,
): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      if (onTimeOut) {
        onTimeOut();
      }
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
